import {View, TouchableOpacity, StyleSheet } from 'react-native';
import React from 'react';
import coverPhoto from '../../assets/CoverPage.png'
import { useNavigate } from 'react-router-dom';

export default function StartPage() {
    const navigate = useNavigate();
    const handleButtonClick = () => {
        navigate('/home');
    };
  
    return (
      <View style={styles.container}>
  <TouchableOpacity style={styles.container} onPress={handleButtonClick}>
        <img
          src={coverPhoto}
        />
      </TouchableOpacity>
</View>
  )}

  
  const styles = StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: '#fff',
      alignItems: 'center',
      justifyContent: 'center',
      width: "100%",
    },
  });